<template>
  <svg
    class="inline-icon"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="#052E37"
  >
    <path
      d="M11 19v-6H5v-2h6V5h2v6h6v2h-6v6Z"
      stroke-width="1"
    />
  </svg>
</template>

<script lang="ts">
export default {};
</script>